import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoDescripcionAlineacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoDescripcionAlineacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getProyectoDescripcionAlineacionService(): Observable<
    BodyListResponse<ProyectoDescripcionAlineacionDTO>
  > {
    return this.http.get<BodyListResponse<ProyectoDescripcionAlineacionDTO>>(
      API_URL + '/api/v1/proyectoDescripcionAlineacion/todos',
    );
  }

  guardarProyectoDescripcionAlineacionService(
    proyectoDescripcionAlineacionDTO: ProyectoDescripcionAlineacionDTO,
  ): Observable<BodyResponse<ProyectoDescripcionAlineacionDTO>> {
    return this.http.post<BodyResponse<ProyectoDescripcionAlineacionDTO>>(
      API_URL + '/api/v1/proyectoDescripcionAlineacion',
      proyectoDescripcionAlineacionDTO,
    );
  }

  getProyectoDescripcionAlineacionPorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ProyectoDescripcionAlineacionDTO>> {
    return this.http.get<BodyResponse<ProyectoDescripcionAlineacionDTO>>(
      API_URL + '/api/v1/proyectoDescripcionAlineacion/' + codigo,
    );
  }
}
